var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * One chat message in the match's chat log (the synced backing for the
 * bottom-left chat panel). Append-only and capped on the server; each entry
 * snapshots the sender's name/seat so it still renders correctly after that
 * player (or spectator) leaves. `id` is a monotonic server sequence for stable
 * client keys — entries can be dropped off the front once the log is capped.
 * Emoji are allowed in `text` (stored as-is; only length is bounded).
 */
export class ChatMessage extends Schema {
    constructor() {
        super(...arguments);
        /** Monotonic id assigned by the server — stable across chat-log trimming. */
        this.id = 0;
        /** Session id of the sender (players AND spectators may chat). */
        this.senderId = "";
        /** The sender's display name, snapshotted so it survives them leaving. */
        this.senderName = "";
        /** The sender's seat, snapshotted — drives the seat colour on their name.
         * `SPECTATOR_SEAT` (255) for a spectator, who holds no seat. */
        this.seat = 0;
        /** The message body. Emoji allowed; length-bounded on the server. */
        this.text = "";
        /** Wall-clock epoch ms when the server accepted the message. */
        this.at = 0;
    }
}
__decorate([
    type("uint32")
], ChatMessage.prototype, "id", void 0);
__decorate([
    type("string")
], ChatMessage.prototype, "senderId", void 0);
__decorate([
    type("string")
], ChatMessage.prototype, "senderName", void 0);
__decorate([
    type("uint8")
], ChatMessage.prototype, "seat", void 0);
__decorate([
    type("string")
], ChatMessage.prototype, "text", void 0);
__decorate([
    type("number")
], ChatMessage.prototype, "at", void 0);
/** Sentinel `seat` for a message sent by a spectator (no seat / neutral colour). */
export const SPECTATOR_SEAT = 255;
//# sourceMappingURL=ChatMessage.js.map